import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'

const PromoCallout = ({promotionMessage, ...props}) => {
    // calloutMsg can be html string or just plain text
    return (
        <Box {...props} data-testid="promo-callout">
            {promotionMessage}
        </Box>
    )
}

PromoCallout.propTypes = {
    promotionMessage: PropTypes.string
}

export default PromoCallout
